import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useI18n } from '../content/i18n';
import PhoneGalleryAnimation from './PhoneGalleryAnimation';
import './FeaturesDetailSection.css';

gsap.registerPlugin(ScrollTrigger);

const FeaturesDetailSection = () => {
  const { t, isKo } = useI18n();
  const sectionRef = useRef(null);
  const featureLabelRef = useRef(null);
  const titleRef = useRef(null);
  const contentRef = useRef(null);
  const phoneAnimationRef = useRef(null);
  
  useEffect(() => {
    const ctx = gsap.context(() => {
      // "특징" 라벨이 작게 시작해서 커지는 애니메이션
      gsap.fromTo(
        featureLabelRef.current,
        { 
          scale: 0.3,
          opacity: 0
        },
        {
          scale: 1,
          opacity: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            end: 'top 30%',
            scrub: 1,
          },
        }
      );

      // 콘텐츠 레이아웃 애니메이션
      gsap.fromTo(
        contentRef.current,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          scrollTrigger: {
            trigger: contentRef.current,
            start: 'top 80%',
            end: 'top 50%',
            scrub: 1,
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section className="features-detail-section" ref={sectionRef}>
      <div className="features-detail-content container container--wide">
        <div className="feature-label" ref={featureLabelRef}>{t.featuresDetail.label}</div>
        
        <div className="content-layout" ref={contentRef}>
          {/* 좌측: 스마트폰 애니메이션 */}
          <div className="animation-container">
            <div className="animation-wrapper-centered">
              <PhoneGalleryAnimation ref={phoneAnimationRef} />
            </div>
          </div>

          {/* 우측: 텍스트 */}
          <div className="text-container" ref={titleRef}>
            <h2 className="section-title">
              {t.featuresDetail.title}
            </h2>
            <p className="section-subtitle">
              {t.featuresDetail.subtitlePrefix}{' '}
              <span className="mimic-brand">{t.common.brand}</span>
              {isKo ? <span className="mimic-korean">{t.common.brandKo}</span> : null}
              {t.featuresDetail.subtitleSuffix}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesDetailSection;
